import {type MouseEventHandler} from 'react';
import {FormattedMessage} from 'react-intl';
import {type ButtonProps} from '@mui/material';
import {Delete} from 'components/icons';
import {IconButton} from 'components/buttons';

export type DeleteIconButtonProps = ButtonProps & {
  labelId?: string;
  onClick?: MouseEventHandler;
};

const DeleteIconButton = ({labelId = 'button.delete', ...props} : DeleteIconButtonProps) : JSX.Element => {
  return (
    <IconButton tooltip={labelId ? <FormattedMessage id={labelId} /> : ''} {...props}>
      <Delete />
    </IconButton>
  );
};

export default DeleteIconButton;